import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {envAwarePost} from '../../util/util'

export const getNewActivityCount = createAsyncThunk(
	'getNewActivityCount',
	async ()=> await envAwarePost(
		'api/notifications/',
		{action:'getNewActivityCount'}
	)
)



const slice = createSlice({
	name: 'activityCount',
	initialState:{count:0},
	reducers: {
		clear: (state) => {
			state.count = 0
		},
		increment: (state) => {
			state.count += 1
		}
	},
	extraReducers:{
		[getNewActivityCount.fulfilled] : (state,action) => {
			state.count = action.payload.data.new_activity_count
		}
	}
})

export const {clear,increment} = slice.actions

export default slice.reducer